import React from "react";
import { motion } from "framer-motion";
import {
  FaReact,
  FaNodeJs,
  FaNetworkWired,
  FaDatabase,
  FaCloud,
  FaLaravel,
  FaVuejs,
  FaJira,
  FaApple,
  FaAngular,
  FaLayerGroup,
  FaCubes,
} from "react-icons/fa";
import {
  SiTypescript,
  SiAdonisjs,
  SiAzuredevops,
  SiConfluence,
  SiIonic,
  SiRedux,
} from "react-icons/si";

const skillGroups = [
  {
    id: 1,
    title: "Frontend & Mobile",
    icon: <FaReact />,
    color: "#61dafb",
    items: [
      { label: "React", value: 85, icon: <FaReact /> },
      { label: "React Native", value: 82, icon: <FaReact /> },
      { label: "TypeScript / JavaScript", value: 88, icon: <SiTypescript /> },
      { label: "Vue / Nuxt", value: 80, icon: <FaVuejs /> },
      { label: "Angular", value: 80, icon: <FaAngular /> },
      { label: "Ionic", value: 80, icon: <SiIonic /> },
    ],
  },
  {
    id: 4,
    title: "UI Libraries & State",
    icon: <FaLayerGroup />,
    color: "#8b5cf6",
    items: [
      { label: "Gluestack UI", value: 78, icon: <FaCubes /> },
      { label: "NativeBase", value: 78, icon: <FaCubes /> },
      { label: "Element UI", value: 75, icon: <FaCubes /> },
      { label: "Chakra UI", value: 80, icon: <FaLayerGroup /> },
      { label: "Redux / RTK", value: 82, icon: <SiRedux /> },
      { label: "RTK Query", value: 80, icon: <SiRedux /> },
      { label: "TanStack Query", value: 80, icon: <FaCubes /> },
    ],
  },
  {
    id: 3,
    title: "Network & Infrastructure",
    icon: <FaNetworkWired />,
    color: "#60efff",
    items: [
      { label: "App Connect", value: 80, icon: <FaApple /> },
      { label: "Azure", value: 80, icon: <SiAzuredevops /> },
      { label: "Jira", value: 80, icon: <FaJira /> },
      { label: "Jira Confluence", value: 80, icon: <SiConfluence /> },
      { label: "ASA / VPN / DMVPN", value: 72, icon: <FaCloud /> },
      { label: "ACLs / ISE", value: 70, icon: <FaNetworkWired /> },
    ],
  },
  {
    id: 2,
    title: "Backend & APIs",
    icon: <FaNodeJs />,
    color: "#68a063",
    items: [
      { label: "Node.js / Express", value: 75, icon: <FaNodeJs /> },
      { label: "Laravel", value: 80, icon: <FaLaravel /> },
      { label: "Adonis js", value: 70, icon: <SiAdonisjs /> },
      { label: "RESTful Services", value: 78, icon: <FaDatabase /> },
    ],
  },
];

const Skill = () => {
  return (
    <motion.section
      className="section skills-modern"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="section-title">
        <h2>Skills & Expertise</h2>
        <div className="underline"></div>
        <p className="skills-subtitle">
          Technical proficiencies across frontend, backend, and network
          infrastructure
        </p>
      </div>

      <div className="skills-grid-modern">
        {skillGroups.map((group, index) => (
          <motion.article
            key={group.id}
            className="skill-card-modern"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="skill-card-header">
              <div
                className="skill-category-icon"
                style={{ color: group.color }}
              >
                {group.icon}
              </div>
              <h3>{group.title}</h3>
            </div>

            <div className="skills-list">
              {group.items.map((item, idx) => (
                <motion.div
                  key={item.label}
                  className="skill-item-modern"
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{
                    delay: index * 0.1 + idx * 0.05,
                    duration: 0.4,
                  }}
                >
                  <div className="skill-item-header">
                    <div className="skill-item-label">
                      <span className="skill-item-icon">{item.icon}</span>
                      <span>{item.label}</span>
                    </div>
                  </div>
                  <div className="skill-bar-container">
                    <motion.div
                      className="skill-bar-fill"
                      initial={{ width: 0 }}
                      animate={{ width: `${item.value}%` }}
                      transition={{
                        delay: index * 0.1 + idx * 0.05 + 0.2,
                        duration: 1,
                        ease: "easeOut",
                      }}
                      style={{
                        background: `linear-gradient(90deg, ${group.color}, ${group.color}dd)`,
                      }}
                    />
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.article>
        ))}
      </div>
    </motion.section>
  );
};

export default Skill;
